import { Component, Input, OnInit } from "@angular/core";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { Community } from "src/app/app/community/community.model";
import { CommunityService } from "src/app/app/community/community.service";
import { AppModule } from "src/app/_helpers/module";

@Component({
  selector: "app-community-tile",
  templateUrl: "./community-tile.component.html",
  styleUrls: ["./community-tile.component.scss"],
})
export class CommunityTileComponent implements OnInit {
  description: SafeHtml;
  appModule = AppModule;

  constructor(
    public communityServ: CommunityService,
    private sanitizer: DomSanitizer
  ) {}

  ngOnInit() {
    if(this.community.description) {
      this.description = this.sanitizer.bypassSecurityTrustHtml(
        this.community.description.replace(/\r?\n|\r/g, "")
      );
    } else {
      this.description = '';
    }
    
  }

  @Input()
  community: Community;

  @Input()
  userServ;
}
